import { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import {
  CLEAR_CART,
} from "../features/productInCartSlice";

const PaymentPending = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const orderId = sessionStorage.getItem(
    "pendingRivhitOrderId"
  );

 useEffect(() => {
  /*
   * הסרת Token ופרמטרים נוספים
   * משורת הכתובת ללא רענון הדף.
   */
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname
  );

  dispatch(CLEAR_CART());

  localStorage.removeItem("cart");

  localStorage.removeItem(
    "pendingCartChanges"
  );

  sessionStorage.removeItem(
    "pendingRivhitOrderId"
  );
}, [dispatch]);

  return (
    <Container maxWidth="sm">
      <Box
        component="main"
        dir="rtl"
        sx={{
          mt: 8,
          p: 4,
          textAlign: "center",
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "#fff",
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
        >
          ההזמנה התקבלה בהצלחה
        </Typography>
        <Typography sx={{ mb: 1 }}>
          פרטי התשלום הוזנו באופן מאובטח במערכת הסליקה.
        </Typography>

        <Typography sx={{ mb: 2 }}>
          ההזמנה ממתינה לבדיקה ולאישור. החיוב הסופי יתבצע רק לאחר אישור ההזמנה.
        </Typography>

        {orderId && (
          <Typography sx={{ mb: 3 }}>
            ההזמנה נשלחה למייל ,  מספר ההזמנה:{" "}
            <strong>{orderId}</strong>
          </Typography>
        )}

        <Button
          variant="contained"
          onClick={() => navigate("/")}
          sx={{ backgroundColor: "#D81B60" }}
        >
          חזרה לדף הבית
        </Button>
      </Box>
    </Container>
  );
};

export default PaymentPending;